/**
 * Rock UCS (No Strain) — frontend API service.
 *
 * Cloned from rockBtsService.ts; URL segment → rockucsns, types → RockUCSNS*.
 * All calls go through apiClient (never raw fetch — raw fetch bypasses MSAL
 * auth and returns 404 in dev).
 *
 * Endpoint: /api/workorderdetails/:workOrderDetailKey/rockucsns
 * Controller: backend/src/controllers/rockUcsNsController.ts (item 4.8)
 * Route:      GET / PUT /:workOrderDetailKey/rockucsns
 *
 * PUT payload expected by the controller (rockUcsNsController.ts):
 *   { general, specimens, conformityReadings, ultrasonicReadings, confirmReset? }
 * (conformity/ultrasonic reading arrays added by BUG-2026-0138 items 5/6 —
 * same shapes as Test A's rockUcsService.ts).
 *
 * The backend's saveTestData() accepts the camelCase general + specimens array
 * (the rowToDto() strip of audit/computed fields makes the camelCase shape
 * usable both ways — the controller's mapFields gates via ENTRY_FIELDS).
 */
import apiClient from './apiClient';
import type { RockUCSNSData, RockUCSNSGeneral, RockUCSNSSpecimen } from '../types/rockUcsNs';
import type { RockUCSConformityReading, RockUCSUltrasonicReading } from '../types/rockUcs';

export const getRockUcsNsData = async (workOrderDetailKey: string): Promise<RockUCSNSData> => {
  const r = await apiClient.get<RockUCSNSData>(
    `/workorderdetails/${workOrderDetailKey}/rockucsns`,
  );
  return r.data;
};

export const saveRockUcsNsData = async (
  workOrderDetailKey: string,
  general: RockUCSNSGeneral,
  specimens: RockUCSNSSpecimen[],
  conformityReadings: RockUCSConformityReading[],
  ultrasonicReadings: RockUCSUltrasonicReading[],
  confirmReset?: boolean,
): Promise<RockUCSNSData> => {
  const r = await apiClient.put<RockUCSNSData>(
    `/workorderdetails/${workOrderDetailKey}/rockucsns`,
    {
      general,
      specimens,
      conformityReadings,
      ultrasonicReadings,
      confirmReset,
    },
  );
  return r.data;
};
